import Project from './Project'
import Support from './Support'
import Contact from './Contact'

export default function Components(Vue) {
  Vue.component('project-request-form', Project)
  Vue.component('support-request-form', Support)
  Vue.component('contact-request-form', Contact)
}
